var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"form-container"},[_vm._t("content",function(){return [_c('h4',[_vm._v("Title")]),_vm._v(" "),_c('h5',{staticClass:"secondary-text"},[_vm._v("Subtitle")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }